var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "download-2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.77,21H3.23c-1.78,0-3.23-1.45-3.23-3.23V6.86c0-1.78,1.45-3.23,3.23-3.23h2.73c.28,0,.5.22.5.5s-.22.5-.5.5h-2.73c-1.23,0-2.23,1-2.23,2.23v10.91c0,1.23,1,2.23,2.23,2.23h14.55c1.23,0,2.23-1,2.23-2.23V6.86c0-1.23-1-2.23-2.23-2.23h-2.73c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h2.73c1.78,0,3.23,1.45,3.23,3.23v10.91c0,1.78-1.45,3.23-3.23,3.23Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.5,15.55c-.13,0-.26-.05-.35-.15l-5.46-5.46c-.2-.2-.2-.51,0-.71s.51-.2.71,0l5.1,5.1,5.1-5.1c.2-.2.51-.2.71,0s.2.51,0,.71l-5.45,5.46c-.09.09-.22.15-.35.15Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10.5,15.54c-.28,0-.5-.22-.5-.5V.5c0-.28.22-.5.5-.5s.5.22.5.5v14.54c0,.28-.22.5-.5.5Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload2);
export default __webpack_public_path__ + "static/media/download-2.6b34b38eac1741a8e2473560b167888a.svg";
export { ForwardRef as ReactComponent };